import React from "react";
import { Box } from "@mui/material";
import useTheme from "../../../../common/hooks/useTheme";
import { Theme } from "../../../../providers/ThemeProvider";

interface PrescriptionTypeBadgeProps {
  sourceType: number;
}

const PrescriptionTypeBadge: React.FC<PrescriptionTypeBadgeProps> = ({
  sourceType,
}) => {
  const theme: Theme = useTheme();
  const text = sourceType === 3 ? "Manual" : "Auto-generated";
  const isAutoGenerated = sourceType === 1;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "4px 8px",
        border:
          sourceType === 1
            ? `1px solid ${theme.colorTokens.N[80]}`
            : sourceType === 2
            ? `1px solid ${theme.colorTokens.W[60]}`
            : `1px solid ${theme.colorTokens.P[90]}`,
        borderRadius: "8px",
        backgroundColor:
          sourceType === 1
            ? theme.colorTokens.N[20]
            : sourceType === 2
            ? theme.colorTokens.W[10]
            : theme.colorTokens.P[10],
        width: "fit-content",
      }}
    >
      <div style={styles.badgeText(theme)}>
        <div>{text}</div>
        {sourceType === 2 && <div style={styles.dot(theme)} />}
        {sourceType === 2 && <div>Edited</div>}
      </div>
    </Box>
  );
};

export default PrescriptionTypeBadge;

const styles = {
  badgeText: (theme: Theme) => ({
    fontFamily: "var(--font-Medium)",
    fontSize: "12px",
    lineHeight: "19px",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
    display: "flex",
    gap: "10px",
    alignItems: "center",
  }),
  dot: (theme: Theme) => ({
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
  }),
};
